import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import ApartmentForm from './ApartmentForm';

const ApartmentEdit = () => {
  const history = useHistory();
  const location = useLocation();
  
  // This component serves as a wrapper to ensure edit mode
  // The ApartmentForm component already handles edit mode via location.state
  // If no apartment data is provided, redirect back to list
  if (!location.state || !location.state.apartment) {
    history.push('/app/project/ProjectPricing');
    return null;
  }

  return <ApartmentForm />;
};

export default ApartmentEdit;
